import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeDrawer } from 'features/drawersSlice';
import {
    getMiniBookingWidgetData,
    resetAllRoomsUrl,
} from 'features/MiniBookingWidget/MiniBookingWidgetSlice';
import { setSelectedRoom } from 'features/roomsSlice';
import { setCalendarOpen, setTempCheckOutDay } from 'features/userSlice';
import * as constants from '../constants';
import { makeStatsRequest } from 'lib';
import { WIDGET_STATS_SETTINGS } from 'config';
import { calcTotalBookingValue } from 'components/bookingCalendar/helpers';

const useGetBookingData = () => {
    const dispatch = useDispatch();

    const calendar = useSelector(
        (state) => state.miniBookingWidget?.data?.futureDates
    );
    const userProvidedData = useSelector((state) => state.user);

    const totalBookingValue = useMemo(
        () =>
            calcTotalBookingValue(
                userProvidedData.checkInDay,
                userProvidedData.checkOutDay,
                calendar
            ),
        [userProvidedData.checkInDay?.date, userProvidedData.checkOutDay?.date]
    );

    const userBookingData = {
        adults: userProvidedData.adults,
        checkin: userProvidedData.checkInDay?.date,
        checkout: userProvidedData.checkOutDay?.date,
        children: userProvidedData.children,
        currency: userProvidedData.currency,
        localeLanguage: userProvidedData.language,
        rooms: userProvidedData.numberOfRooms,
        sortBy: userProvidedData.sortBy,
        totalBookingValue,
    };

    const parentPropertyIdMain = useSelector(
        (state) => state?.miniBookingWidget.data?.parentPropertyID
    );

    const thisPropertyID = useSelector(
        (state) => state?.miniBookingWidget.data?.propertyID
    );

    const multiproperty = useSelector(
        (state) =>
            state?.miniBookingWidget.data?.smallWidget ===
                constants.MULTIPROPERTY ||
            state?.miniBookingWidget.data?.smallWidget ===
                constants.MOBILE_MULTIPROPERTY
    );

    const getBookingData = ({
        currency,
        language,
        sortBy = '',
        propertyId,
        parentPropertyId,
        checkInDate,
        checkOutDate,
    } = {}) => {
        if (!parentPropertyId) {
            parentPropertyId = parentPropertyIdMain;
        }
        dispatch(setCalendarOpen({ isCalendarOpen: false }));

        // Reset temp check out day
        dispatch(setTempCheckOutDay({ day: null }));

        dispatch(
            getMiniBookingWidgetData({
                ...userBookingData,
                checkin: checkInDate || userBookingData?.checkin,
                checkout: checkOutDate || userBookingData?.checkout,
                currency: currency || userBookingData?.currency,
                localeLanguage: language || userBookingData?.localeLanguage,
                sortBy: sortBy || userBookingData?.sortBy,
                livePrices: Boolean(multiproperty),
                propertyId,
                parentPropertyId,
                isMultipropertyStill: multiproperty,
            })
        );

        // Reset all rooms url in order to refetch room data
        dispatch(resetAllRoomsUrl());
        // Close room details
        dispatch(setSelectedRoom({ selectedRoomIndex: null }));
        dispatch(closeDrawer({ drawerId: 'MapDrawer' }));

        makeStatsRequest(
            WIDGET_STATS_SETTINGS.actions.search,
            thisPropertyID,
            userBookingData
        );
    };
    return { userBookingData, getBookingData };
};

export default useGetBookingData;
